module.exports = __webpack_public_path__ + "static/media/image_greenblue.56156bd5.png";